import { t } from "@/languages/i18n"
import { CustomerFieldConfig, ReceiveSMS } from "@/types/types"

export const RECEIVE_SMS_OPTIONS = [
  { label: "no", value: ReceiveSMS.NO },
  { label: "cz", value: ReceiveSMS.CS },
  { label: "vn", value: ReceiveSMS.VN },
  { label: "en", value: ReceiveSMS.EN },
]

export const YES_NO_RADIO_OPTIONS = [
  { label: "No", value: false },
  { label: "Yes", value: true },
]

export const CUSTOMER_FIELDS_CONFIG: CustomerFieldConfig[] = [
  // Left Column
  {
    name: "ico",
    labelKey: "Ico",
    type: "input",
    column: "left",
  },
  {
    name: "businessName",
    labelKey: "Business Name",
    type: "input",
    column: "left",
  },
  {
    name: "phone",
    labelKey: "Phone",
    type: "input",
    column: "left",
    rules: [
      { required: true, message: ("Vui lòng nhập số điện thoại") },
      {
        pattern: /^[+0-9\s]+$/,
        message: t("Số điện thoại chỉ được chứa các chữ số từ 0-9")
      }
    ]
  },
  {
    name: "email",
    labelKey: "Email",
    type: "input",
    column: "left",
  },
  {
    name: "address",
    labelKey: "Address",
    type: "input",
    column: "left",
  },
  {
    name: "city",
    labelKey: t("Thành phố"),
    type: "input",
    column: "left",
  },
  {
    name: "receiveAtSore",
    labelKey: t("Nhận tại cửa hàng"),
    type: "input",
    column: "left",
  },
  {
    name: "receiveSMS",
    labelKey: "Receive SMS",
    type: "select",
    initialValue: ReceiveSMS.NO,
    options: RECEIVE_SMS_OPTIONS,
    column: "left",
  },
  {
    name: "idNumber",
    labelKey: "Id Number",
    type: "input",
    column: "left",
  },
  {
    name: "fullname",
    labelKey: "Fullname",
    type: "input",
    column: "left",
  },
  {
    name: "birthNumber",
    labelKey: "Birth Number",
    type: "input",
    column: "left",
  },

  // Right Column
  {
    name: "dic",
    labelKey: "Dic",
    type: "input",
    column: "right",
  },
  {
    name: "businessRepresentative",
    labelKey: "Business Representative",
    type: "input",
    column: "right",
  },
  {
    name: "dphRegistered",
    labelKey: "Dph Registered",
    type: "radio",
    initialValue: false,
    rules: [{ required: true }],
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
  {
    name: "countryOrState",
    labelKey: "Country or State",
    type: "input",
    column: "right",
  },
  {
    name: "haveVAT",
    labelKey: "Have VAT",
    type: "radio",
    initialValue: false,
    rules: [{ required: true }],
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
  {
    name: "signature",
    labelKey: "Signature",
    type: "media",
    column: "right",
  },
  {
    name: "occupation",
    labelKey: "Occupation",
    type: "input",
    column: "right",
  },
  {
    name: "registrationCode",
    labelKey: "Registration Code",
    type: "input",
    column: "right",
  },
  {
    name: "isSentEmail",
    labelKey: "Is Sent Email",
    type: "radio",
    initialValue: false,
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
  {
    name: "isResolved",
    labelKey: "Is Resolved",
    type: "radio",
    initialValue: false,
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
]

export const getLeftColumnFields = () => CUSTOMER_FIELDS_CONFIG.filter(field => field.column === "left")

export const getRightColumnFields = () => CUSTOMER_FIELDS_CONFIG.filter(field => field.column === "right")
